
export const diagramColors = {
    purple: {
        border: "#d048b6", 
        gradient: ["rgba(72,72,176,0.1)", "rgba(72,72,176,0.0)", "rgba(119,52,169,0)"], 
        palette: ['#d048b6', '#c042a6', '#b03c96','#a03686', '#9234a2', '#e980c6', '#f3b2db']}, 
    red: {
        border: "#f96332", 
        gradient: ["rgba(249, 99, 59, 0.20)", "rgba(249, 99, 59, 0.0)", "rgba(128, 182, 244, 0)"],
        palette: ['#f96332', '#e0582c', '#c74e26','#af4420', '#d84c2a', '#fa8763', '#ffb099']}, 
    green: {
        border: "#00d6b4", 
        gradient: ["rgba(66,134,121,0.15)", "rgba(66,134,121,0.0)", "rgba(66,134,121,0)"],
        palette: [ '#00d6b4', '#00c1a4', '#00ab93', '#009c86', '#007d6d', '#33e0c3', '#66ecd3']}, 
    darkBlue: {
        palette: ["#0c3b5e", "#0f548c", "#0f6cbd"]},
    blue: {
        border: "#1f8ef1", 
        gradient: ["rgba(29,140,248,0.2)", "rgba(29,140,248,0.0)", "rgba(29,140,248,0)"],
        palette: ['#1e90ff', '#187bcd', '#1364a2', '#0d4e78', '#0963b2', '#63aefc', '#9cd1fd']}, 
    yellow: {
        border: "#ffc107", 
        gradient: [ "rgba(255, 193, 7, 0.2)", "rgba(255, 193, 7, 0.0)", "rgba(255, 214, 51, 0)"],
        palette: ['#ffc107', '#e0a905', '#c39204', '#a77b03', '#e0a905', '#ffd547', '#ffe375']}, 
    orange: {
        palette: ['#ff7f50', '#e66a42', '#cc5636', '#b24229', '#d1553c', '#ff9c75', '#ffc1a1']}, 
    teal: {
        palette: [ '#20c997', '#1bb285', '#179c74', '#128662', '#158f6b', '#3bd9a7', '#60e9b7' ]}
}